import { Component, ElementRef, Input, ViewChild } from '@angular/core';

import { CaGroup } from '../../../core';

@Component({
    selector: 'cmps-ca-evaluation-phase-content',
    templateUrl: './phase-content.component.html',
})
export class PhaseContentComponent {
    @Input()
    group: CaGroup;

    @ViewChild('ref') ref: ElementRef<HTMLElement>;
}
